










import { Vue, Component } from 'vue-property-decorator'
import Typed from 'typed.js'

@Component
export default class Hello extends Vue {
  private mounted () {
    const typed = new Typed('.text',
      {
        strings: [
          'Hello! Thanks for the view. <br /><br /> ^1000' +
          "I'm one who enjoys development! <br /><br />  ^1000" +
          'This is my portfolio! <br /> ^1000' +
          "Below you'll find some of my recent developments. <br /><br /> ^1000" +
          'Please make yourself at home!'
        ],
        typeSpeed: 0,
        showCursor: false
      })
  }
}
